import Slider from "react-slick";
import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import { updateColorImage } from "../../../store/slices/viewSlice";

const VariantSlider = ({ productImage }: any) => {
  const [nav1, setNav1] = useState();
  const dispatch = useAppDispatch();
  const [nav2, setNav2] = useState();
  const productData = useAppSelector((state) => state.product.product_images);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    console.log("productImage:::", productImage);

    // const updatedFiles = files.map(file => ({
    //   ...file,
    //   url: productImage,
    // }));
    // setFiles(updatedFiles);
  }, []);

  useEffect(() => {
    // console.log("productData:::=================", productData);
    const newArray = productData.map((item: any) => ({
      id: item.id,
      url: item.src,
      name: "Test8.jpg",
      type: "image/jpeg",
      size: '496.69 KB / 11.25x9"',
      resolution: "3375 x 2700 @ 300 dpi",
      createdDate: item.created_at,
      ...item,
    }));
    setFiles(newArray);
    // debugger;
    // setFiles(updatedFiles);
  }, [productData]);

  return (
    <>
      <Slider
        asNavFor={nav1}
        ref={(slider2: any) => setNav2(slider2)}
        slidesToShow={5}
        swipeToSlide={true}
        focusOnSelect={true}
        infinite={false}
        className="max-w-[500px] mx-auto"
      >
        {files.map((file: any) => (
          <div
            onClick={() => {
              dispatch(updateColorImage(file));
            }}
            key={file.id}
            className="p-3 w-[60px] h-[60px] max-md:w-[40px] max-md:h-auto"
          >
            <img
              src={file.url}
              className="w-[60px] h-[60px] max-md:w-[40px] max-md:h-auto"
              alt=""
            />
          </div>
        ))}
      </Slider>
    </>
  );
};

export default VariantSlider;
